import React from "react";
import {Navigate, useParams} from "react-router-dom";
import {useNavigationHelper} from "../../../hooks/useNavigationHelper.ts";
import type {PlanogramTemplate} from "../../../types";
import TemplateDetail from "../PlanogramTemplateDetail";

const TemplateDetailWrapper: React.FC<{ onOpenWizard?: (mode: 'create' | 'edit', templateId?: string) => void }> = ({ onOpenWizard }) => {
    const { id } = useParams<{ id: string }>();
    const navigation = useNavigationHelper();

    if (!id) {
        return <Navigate to="/templates" replace />;
    }

    const handleEdit = (template: PlanogramTemplate) => {
        onOpenWizard('edit', template.id);
    };

    const handleDelete = (_templateId: string) => {
        navigation.goToTemplateList();
    };

    const handleBack = () => {
        navigation.goBack();
    };

    return (
        <TemplateDetail
            templateId={id}
            onEdit={handleEdit}
            onDelete={handleDelete}
            onBack={handleBack}
        />
    );
};

export default TemplateDetailWrapper;